import React, { lazy, Suspense } from 'react';
import {
  Redirect, Switch, Route,
} from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import PrivateRoute from './PrivateRoute';
import UnauthRoute from './UnauthRoute';

const LoginScreen = lazy(() => import('../screens/Login/index'));
const RegisterScreen = lazy(() => import('../screens/Register/index'));
const RegisterInviteScreen = lazy(() => import('../screens/RegisterInvite/index'));
const ForgotPasswordScreen = lazy(() => import('../screens/ForgotPassword/index'));
const AuthenticatedScreen = lazy(() => import('../screens/Authenticated/index'));
const SignOutScreen = lazy(() => import('../screens/SignOut/index'));
const EventOverScreen = lazy(() => import('../screens/EventOver/index'));

const Routes = (): React.ReactElement => (
  <Suspense fallback={<LoadingPage isLoading />}>
    <Switch>
      <UnauthRoute exact path="/register" component={RegisterScreen} />
      <UnauthRoute exact path="/invite" component={RegisterInviteScreen} />
      <UnauthRoute exact path="/forgot_password" component={ForgotPasswordScreen} />
      <UnauthRoute exact path="/login" component={LoginScreen} />
      <UnauthRoute exact path="/event_over" component={EventOverScreen} />
      <PrivateRoute exact path="/authenticated" component={AuthenticatedScreen} />
      <Route exact path="/signout" component={SignOutScreen} />
      <Redirect to="/login" />
    </Switch>
  </Suspense>
);

export default Routes;
